import { SVGProps, Ref, forwardRef } from 'react';

export const ItAccreditationCircledSize16Glyph = forwardRef(
    (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
        <svg
            width={16}
            height={16}
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            ref={ref}
            {...props}
        >
            <g>
                <path d="M10.364 11.664V7.965h.966v-1.4h-.966v-1.9h-1.4v1.9h-.966v1.4h.966v3.7z" fill="currentColor" />
                <path d="M7.032 6.565v5.1h-1.4v-3.7h-.967v-1.4z" fill="currentColor" />
                <path d="M6.332 5.866a1.033 1.033 0 1 0 0-2.067 1.033 1.033 0 0 0 0 2.067" fill="currentColor" />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M8 .5C2.375.5.5 4.25.5 8s1.875 7.5 7.5 7.5 7.5-3.75 7.5-7.5S13.625.5 8 .5M3.216 3.74C2.32 4.816 1.9 6.333 1.9 8s.42 3.184 1.316 4.26C4.076 13.291 5.524 14.1 8 14.1s3.925-.809 4.784-1.84C13.68 11.184 14.1 9.667 14.1 8s-.42-3.184-1.316-4.26C11.924 2.71 10.476 1.9 8 1.9s-3.925.809-4.784 1.84"
                    fill="currentColor"
                />
            </g>
        </svg>
    )
);
ItAccreditationCircledSize16Glyph.displayName = 'ItAccreditationCircledSize16Glyph';
